import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  endDateParamsSelector,
  searchParamsSelector,
  selectedAnnotatorsSelector,
  selectedEffortsSelector,
  selectedGridsSelector,
  startDateParamsSelector,
} from '../selectors/admin.selectors';

export const useUpdateURLSearchParams = () => {
  const [, setSearchParams] = useSearchParams();
  const searchInput = useSelector(searchParamsSelector);
  const startDate = useSelector(startDateParamsSelector);
  const endDate = useSelector(endDateParamsSelector);
  const selectedAnnotators = useSelector(selectedAnnotatorsSelector);
  const selectedGrids = useSelector(selectedGridsSelector);
  const selectedEfforts = useSelector(selectedEffortsSelector);

  useEffect(() => {
    const paramsToUpdate = {
      ...(searchInput !== '' ? { searchInput } : {}),
      ...(startDate !== '' ? { startDate } : {}),
      ...(endDate !== '' ? { endDate } : {}),
      ...(endDate !== '' ? { endDate } : {}),
      ...(selectedAnnotators.length > 0 ? { selectedAnnotators } : {}),
      ...(selectedGrids.length > 0 ? { selectedGrids } : {}),
      ...(selectedEfforts.length > 0 ? { selectedEfforts } : {}),
    };
    setSearchParams(paramsToUpdate);
  }, [
    endDate,
    searchInput,
    selectedAnnotators,
    selectedGrids,
    setSearchParams,
    startDate,
    selectedEfforts,
  ]);
};
